import React, {Component} from 'react'

class NoBaskets extends Component {
    render() {
        return (
            <div className='NoBaskets'>
                <i>Chưa có giỏ nào</i>
            </div>
        )
    }
}

export default NoBaskets
